import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
  },
  {
    path: '/useinfo',
    name: 'useinfo',
    component: () => import(/* webpackChunkName: "about" */ '../views/UseInfo.vue')
  },
  {
    path: '/examples',
    name: 'examples',
    component: () => import(/* webpackChunkName: "about" */ '../views/Examples.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
